import React from "react";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import Typography from "@mui/material/Typography";

export default function SelectApp() {
  return (
    <>
      <Typography
        variant="h6"
        gutterBottom
        p={1}
        sx={{ textAlign: "center", fontWeight: "bold" }}
        color="primary"
      >
        Pentru a vă putea programa, vă rugăm să alegeți specialitarea
      </Typography>
      <Grid
        container
        spacing={1}
        justifyContent="center"
        alignItems="center"
        sx={{ mt: 4 }}
      >
        <Grid item xs={12} sm={3}>
          <Button
            component={Link}
            to="/Reumatologie"
            variant="contained"
            size="large"
            sx={{ minHeight: 100 }}
            fullWidth
          >
            Reumatologie
          </Button>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Button
            component={Link}
            to="/Recuperare%20Medicala"
            variant="contained"
            size="large"
            sx={{ minHeight: 100 }}
            fullWidth
          >
            Recuperare Medicala
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
